module.exports = __webpack_public_path__ + "img/icon-step-4.207820e2.svg";